import React, { useState, useCallback, useRef } from 'react';
import Toast from './Toast';

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  const toastIdRef = useRef(0);

  const addToast = useCallback(({
    type = 'info',
    title,
    message,
    duration = 5000,
    autoClose = true
  }) => {
    const id = ++toastIdRef.current;
    const newToast = { 
      id, 
      type, 
      title, 
      message, 
      duration, 
      autoClose,
      createdAt: Date.now()
    };
    
    setToasts(prev => [...prev, newToast]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const removeAllToasts = useCallback(() => {
    setToasts([]);
  }, []);

  // Expose methods to parent via ref
  React.useImperativeHandle(
    typeof window !== 'undefined' && window.toastContainerRef ? window.toastContainerRef : null,
    () => ({
      addToast,
      removeToast,
      removeAllToasts
    }),
    [addToast, removeToast, removeAllToasts]
  );

  // Store reference in window for global access
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      window.toastManager = {
        addToast,
        removeToast,
        removeAllToasts
      };
    }
    return () => {
      if (typeof window !== 'undefined') {
        delete window.toastManager;
      }
    };
  }, [addToast, removeToast, removeAllToasts]);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm w-full">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={removeToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;